window.addEventListener("scroll", function() {
    let browserWindow = window.pageYOffset + 160;

    // Side Menu Active Title
    const sideNavTitleActive = 'tarieven__nav-title--active';

    // Side Menu Active SVG
    const sideNavSVGActive = 'tarieven__nav-svg--active';

    // Behandeling Sections
    const tarievenLasertherapie = document.querySelector('#lasertherapie-tarieven');
    const tarievenHuidtherapie = document.querySelector('#huidtherapie-tarieven');
    const tarievenMesotherapie = document.querySelector('#mesotherapie-tarieven');
    const tarievenMesoestetic = document.querySelector('#mesoestetic-tarieven');
    const tarievenPMU = document.querySelector('#permanente-make-up-tarieven');
    const tarievenCamou = document.querySelector('#camouflagetherapie-tarieven');



    if (tarievenLasertherapie.offsetTop <= browserWindow && tarievenHuidtherapie.offsetTop > browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

    }

    else if (tarievenHuidtherapie.offsetTop <= browserWindow && tarievenMesotherapie.offsetTop > browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }
    }

    else if (tarievenMesotherapie.offsetTop <= browserWindow && tarievenMesoestetic.offsetTop > browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }
    }

    else if (tarievenMesoestetic.offsetTop <= browserWindow && tarievenPMU.offsetTop > browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }
    }

    else if (tarievenPMU.offsetTop <= browserWindow && tarievenCamou.offsetTop > browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }
    }

    else if (tarievenCamou.offsetTop <= browserWindow) {

        if(tarievenLasertherapie !== null) {
            // Indicaties
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".lasertherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenHuidtherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".huidtherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesotherapie !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesotherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenMesoestetic !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".mesoestetic-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenPMU !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-title").classList.remove(sideNavTitleActive);
            document.querySelector(".permanente-make-up-link-tarieven").querySelector(".tarieven__nav-svg").classList.remove(sideNavSVGActive);
        }

        if(tarievenCamou !== null) {
            // Wat u vooraf moet weten
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-title").classList.add(sideNavTitleActive);
            document.querySelector(".camouflagetherapie-link-tarieven").querySelector(".tarieven__nav-svg").classList.add(sideNavSVGActive);
        }
    }
});



jQuery(function () {
    jQuery('a[href*=\\#]:not([href=\\#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname ==
            this.hostname) {

            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                jQuery('html,body').animate({
                    scrollTop: target.offset().top - 160
                }, 500);
                return false;
            }
        }
    });
});